import { render, staticRenderFns } from "./ViewDeal.vue?vue&type=template&id=58d67d70&scoped=true"
import script from "./ViewDeal.vue?vue&type=script&lang=js"
export * from "./ViewDeal.vue?vue&type=script&lang=js"
import style0 from "./ViewDeal.vue?vue&type=style&index=0&id=58d67d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d67d70",
  null
  
)

export default component.exports